import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { CommandBarButton, IconButton, PrimaryButton } from '@fluentui/react';
import { isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrZero, showMessage } from '../../../common/Helpers';
import { action_setPolinomyStructurePolinomy_ItemCodigoContrato } from '../../../reducers/actions/Adjustment/actions';
import TablePolynomyItems from '../../../components/Products/sAdjustment/Polynomy/TablePolynomyItems';
import { __MessageTypes, enum_CONTACTPARTIE_POLINOMY_FORM_VIEW } from '../../../common/Dictionaries';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import JqxNumberInput from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxnumberinput';
import CLabel from '../../../components/Common/CLabel';
import { getAdjustmentCalculatePolinomy } from '../../../services/sAdjustment/structure.service';
import MessageBox from '../../../components/Common/Message/MessageBox';

const ParentTableItem = ({ tableItem }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const {
    _filter_SelectedPeriod: filter_SelectedPeriod,
  } = useSelector((state) => state.adjustmentState);

  const [amount, setAmount] = useState(null);
  const [calculatedFired, setCalculatedFired] = useState(false);

  const [messageConfig, setMessageConfig] = useState({
      message : null,
      messageType : "",
      showMessage : false,
  });

  const handleToggleRow = (item) => {
    item.collapse = isNullUndefinedOrEmpty(item.collapse) ? false : !item.collapse
    dispatch(action_setPolinomyStructurePolinomy_ItemCodigoContrato(item))
  };

  
  const onCalculate = () =>{
    getAdjustmentCalculatePolinomy(tableItem.l_polinomios, filter_SelectedPeriod).then((response) => {
      if (response.data.succeeded) {
        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
        setCalculatedFired(true)
      }
      else {
        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        setCalculatedFired(true)
      }
    }).catch(() => {
      showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
      setCalculatedFired(true)
    });
  }

  const onChangeAmount = (value) =>{
    setAmount(value)
  }

  const handleDeletePolynomyClick = (dispatch, tableItemId, parentType, contractParties, t) =>{
    
  }

  return (
    <>
      <tr>
        <td className='text-end'>
          <IconButton iconProps={{ iconName:((!isNullUndefinedOrEmpty(tableItem.collapse) ? tableItem.collapse : true) ? "CirclePlus" : "Blocked2") }} onClick={() => handleToggleRow(tableItem)}/>
        </td>
        <td><span>{tableItem.codigoContrato}</span></td>
          {
            (!isNullUndefinedOrEmptyOrZero(tableItem.partidaId) && isNullUndefinedOrEmptyOrZero(tableItem.subpartidaId)) &&
            <>
              <td><span>{tableItem.codigoPartida}</span></td>
              <td><span>{tableItem.nombrePartida}</span></td>
              <td><span>{tableItem.clasePartida}</span></td>
            </>
          }
          {
            (isNullUndefinedOrEmptyOrZero(tableItem.partidaId) && !isNullUndefinedOrEmptyOrZero(tableItem.subpartidaId)) &&
            <>
              <td><span>{tableItem.codigoSubpartida}</span></td>
              <td><span>{tableItem.nombreSubpartida}</span></td>
              <td><span>{tableItem.claseSubpartida}</span></td>
            </>
          }
        </tr>
      {
        (!(!isNullUndefinedOrEmpty(tableItem.collapse) ? tableItem.collapse : true) && tableItem.l_polinomios.length > 0) &&
        <tr>
          <td colSpan={5}>
            <Row>
              <Col>
                <Row>
                  <TablePolynomyItems
                    tableItems={tableItem.l_polinomios}
                    handleDeletePolynomy={handleDeletePolynomyClick}
                    polynomyViewType={enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.COMPLEX_VEW}
                    itemClass={'col'}
                    itemBodyClass={'px-1'}
                  />
                </Row>
              </Col>
              <Col className='col-auto me-auto p-1'>
                <Card className="polinomio poliBlanco me-1 h-100 w-100">
                  <Card.Body className='p-1'>
                    <Row>
                      <Col>
                        <PrimaryButton iconProps={{iconName: 'Calculator'}} className='w-100 px-0' onClick={ onCalculate }>{ t('data-lang-btn-calculate') }</PrimaryButton>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <CLabel labelText={ t('data-lang-lbl-amount') } />
                        <JqxNumberInput
                          height={25}
                          width={"100%"}
                          decimalDigits={5}
                          digits={12}
                          symbolPosition={'right'}
                          value={amount}
                          groupSeparator= ','
                          decimalSeparator= '.'
                          onChange={(event) => onChangeAmount(event.args.value)}
                          className='adjustment-calculated-amount'
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Body className='p-1 pt-4 border-top'>
                    {
                      !isNullUndefinedOrEmptyOrZero(amount) &&
                      <Row><Col><span>{t('data-lang-lbl-factor')}: </span><span>147.78</span></Col></Row>
                    }
                    <Row><Col><span>{t('data-lang-lbl-adjustment')}: </span><span>147.78</span></Col></Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
              {
              calculatedFired &&
              <Row>
                <Col xl={12}>
                  {
                    messageConfig.messageType === __MessageTypes.ERROR &&
                    <Row>
                      <Col xl={12}>
                        <MessageBox
                          inputParam_Message={ messageConfig.message }
                          inputParam_Display={ messageConfig.showMessage }
                          inputParam_MessageType={ messageConfig.messageType }
                          inputParam_SetterMessage={ setMessageConfig }
                        />
                      </Col>
                    </Row>
                  }
                  <Row>
                    <Col>
                      {t('data-lang-lbl-detail')}
                    </Col>
                    {
                      messageConfig.messageType === __MessageTypes.SUCCESS &&
                      <Col className='col-auto me-auto'>
                        <MessageBox
                          inputParam_Message={ messageConfig.message }
                          inputParam_Display={ messageConfig.showMessage }
                          inputParam_MessageType={ messageConfig.messageType }
                          inputParam_SetterMessage={ setMessageConfig }
                        />
                      </Col>
                    }
                  </Row>
                </Col>
              </Row>
              }
            </td>
        </tr>
      }
    </>
  );
};

ParentTableItem.propTypes = {
  tableItem: PropTypes.shape({
    codigoContrato: PropTypes.string,
    esCabecera: PropTypes.bool,
    codigoPartida: PropTypes.string,
    codigoSubPartida: PropTypes.string,
  }),
};

ParentTableItem.defaultProps = {
  tableItem: {
    codigoContrato: "CONTRATO01",
    esCabecera: true,
    codigoPartida: "PARTIDA01",
    codigoSubPartida: "SUBPARTIDA01",
  },
};

export default ParentTableItem;
